import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface RefundReportSkeletonProps {
  title: string;
  description: string;
  rows?: number;
  columns?: number;
}

export const RefundReportSkeleton: React.FC<RefundReportSkeletonProps> = ({
  title,
  description,
  rows = 3,
  columns = 5,
}) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="space-y-2 flex-1">
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          <Skeleton className="h-10 w-[200px]" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="w-full overflow-x-auto border border-gray-300 rounded-lg">
          <div className="min-w-full inline-block">
            <table className="w-full border-collapse">
              {/* Header skeleton */}
              <thead>
                <tr className="bg-gray-50 border-b border-gray-300">
                  {Array.from({ length: columns }).map((_, idx) => (
                    <th
                      key={idx}
                      className="px-3 py-2 text-xs font-semibold border-r border-gray-300 last:border-r-0"
                    >
                      <Skeleton className="h-4 w-full" />
                    </th>
                  ))}
                </tr>
              </thead>

              {/* Body skeleton */}
              <tbody className="bg-white">
                {Array.from({ length: rows }).map((_, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className="border-b border-gray-200 last:border-b-0"
                  >
                    {Array.from({ length: columns }).map((_, colIndex) => (
                      <td
                        key={colIndex}
                        className="px-3 py-2 border-r border-gray-200 last:border-r-0"
                      >
                        <Skeleton className="h-4 w-full" />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
